(function () {

    'use strict';

    console.log('POOJAPAATH SEARCH JS LOADED');


    /* =========================================
       CREATE CUSTOM SEARCH
       ========================================= */

    function createPoojaPaathSearch() {

        // Already exists
        if (document.querySelector('#poojapaath-custom-search')) {
            return;
        }

        // Find header
        const header = document.querySelector('#header-toolbar');

        if (!header) {
            console.log('Header not found');
            return;
        }


        /* =========================================
           FORM
           ========================================= */

        const form = document.createElement('form');

        form.id = 'poojapaath-custom-search';

        // IMPORTANT:
        // Give it the class expected by predictive search
        form.className = 'search-form';

        form.action = '/search';

        form.method = 'get';

        form.setAttribute('role', 'search');


        /* =========================================
           SEARCH WRAPPER
           ========================================= */

        const wrapper = document.createElement('div');

        wrapper.className = 'search-wrapper';


        /* =========================================
           INPUT
           ========================================= */

        const input = document.createElement('input');

        input.type = 'text';

        input.name = 'q';

        input.className = 'search-field';

        input.placeholder =
            'Search for Ganesh Idols, Khes, Pooja Items...';

        input.setAttribute(
            'aria-label',
            'Search products'
        );

        input.setAttribute(
            'autocomplete',
            'off'
        );


        /* =========================================
           SEARCH BUTTON
           ========================================= */

        const button = document.createElement('button');

        button.type = 'submit';

        button.className = 'search-btn';

        button.setAttribute(
            'aria-label',
            'Search'
        );

        button.setAttribute(
            'title',
            'Search'
        );

        button.innerHTML = `
            <svg
                viewBox="0 0 24 24"
                aria-hidden="true"
                focusable="false"
            >
                <circle
                    cx="10.5"
                    cy="10.5"
                    r="6.5"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                ></circle>

                <line
                    x1="15.5"
                    y1="15.5"
                    x2="21"
                    y2="21"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                ></line>
            </svg>
        `;


        /* =========================================
           PREDICTIVE SEARCH DROPDOWN
           ========================================= */

        const dropdown = document.createElement('div');

        dropdown.className = 'search-dropdown';

        dropdown.setAttribute(
            'aria-live',
            'polite'
        );


        /* =========================================
           BUILD SEARCH
           ========================================= */

        wrapper.appendChild(input);

        wrapper.appendChild(button);

        wrapper.appendChild(dropdown);

        form.appendChild(wrapper);


        /* =========================================
           ADD TO HEADER
           ========================================= */

        header.appendChild(form);


        console.log(
            'PoojaPaath custom search created'
        );


        /* =========================================
           PREDICTIVE SEARCH
           ========================================= */

        setupPredictiveSearch(
            form,
            input,
            dropdown
        );
    }


    /* =========================================
       PREDICTIVE SEARCH FUNCTION
       ========================================= */

    function setupPredictiveSearch(
        form,
        input,
        dropdown
    ) {

        let timeout = null;


        /* =========================================
           SUBMIT
           ========================================= */

        form.addEventListener(
            'submit',
            function (e) {

                const query =
                    input.value.trim();

                if (query.length < 2) {

                    e.preventDefault();

                    return;
                }
            }
        );


        /* =========================================
           TYPING
           ========================================= */

        input.addEventListener(
            'input',
            function () {

                clearTimeout(timeout);

                const query =
                    this.value.trim();

                console.log(
                    'Searching:',
                    query
                );


                /* ---------------------------------
                   LESS THAN 2 CHARACTERS
                   --------------------------------- */

                if (query.length < 2) {

                    dropdown.innerHTML = '';

                    dropdown.style.display =
                        'none';

                    return;
                }


                /* ---------------------------------
                   WAIT 300ms
                   --------------------------------- */

                timeout = setTimeout(
                    function () {

                        fetchPredictiveResults(
                            query,
                            dropdown
                        );

                    },
                    300
                );
            }
        );


        /* =========================================
           CLOSE WHEN CLICKING OUTSIDE
           ========================================= */

        document.addEventListener(
            'click',
            function (e) {

                if (
                    !form.contains(e.target)
                ) {

                    dropdown.style.display =
                        'none';
                }
            }
        );


        /* =========================================
           ESCAPE KEY
           ========================================= */

        input.addEventListener(
            'keydown',
            function (e) {

                if (e.key === 'Escape') {

                    dropdown.style.display =
                        'none';
                }
            }
        );
    }


    /* =========================================
       FETCH SHOPIFY PREDICTIVE SEARCH
       ========================================= */

    function fetchPredictiveResults(
        query,
        dropdown
    ) {

        console.log(
            'Fetching predictive results...'
        );


        const url =
            `/search/suggest.json?q=${encodeURIComponent(query)}` +
            `&resources[type]=product` +
            `&resources[limit]=6`;


        fetch(url)

            .then(function (response) {

                if (!response.ok) {

                    throw new Error(
                        'Search request failed'
                    );
                }

                return response.json();
            })


            .then(function (data) {

                console.log(
                    'Predictive search data:',
                    data
                );


                const products =
                    data.resources &&
                    data.resources.results &&
                    data.resources.results.products
                        ? data.resources.results.products
                        : [];


                /* ---------------------------------
                   NO PRODUCTS
                   --------------------------------- */

                if (!products.length) {

                    dropdown.innerHTML = `
                        <div class="search-no-results">
                            No products found
                        </div>
                    `;

                    dropdown.style.display =
                        'block';

                    return;
                }


                /* ---------------------------------
                   PRODUCTS
                   --------------------------------- */

                let html = '';


                products.forEach(
                    function (product) {

                        const image =
                            product.image ||
                            '';


                        const price =
                            product.price
                                ? Number(
                                    product.price
                                  ).toFixed(2)
                                : '';


                        html += `
                            <a
                                href="${product.url}"
                                class="search-item"
                            >

                                ${
                                    image
                                        ? `
                                            <img
                                                src="${image}"
                                                alt="${escapeHtml(product.title)}"
                                                class="search-image"
                                            >
                                          `
                                        : ''
                                }

                                <div class="search-info">

                                    <div class="search-title">
                                        ${escapeHtml(product.title)}
                                    </div>

                                    ${
                                        price
                                            ? `
                                                <div class="search-price">
                                                    C$${price}
                                                </div>
                                              `
                                            : ''
                                    }

                                </div>

                            </a>
                        `;
                    }
                );


                /* ---------------------------------
                   VIEW ALL
                   --------------------------------- */

                html += `
                    <a
                        class="search-all"
                        href="/search?q=${encodeURIComponent(query)}"
                    >
                        View all results →
                    </a>
                `;


                dropdown.innerHTML = html;

                dropdown.style.display =
                    'block';
            })


            .catch(function (error) {

                console.error(
                    'Predictive search error:',
                    error
                );

                dropdown.innerHTML = '';

                dropdown.style.display =
                    'none';
            });
    }


    /* =========================================
       ESCAPE HTML
       ========================================= */

    function escapeHtml(text) {

        const div =
            document.createElement('div');

        div.textContent =
            text || '';

        return div.innerHTML;
    }


    /* =========================================
       HIDE ORIGINAL AVENUE SEARCH
       ========================================= */

    function hideOriginalSearch() {

        document
            .querySelectorAll(
                '#header-toolbar .header-searchbar.search'
            )
            .forEach(
                function (element) {

                    element.style.setProperty(
                        'display',
                        'none',
                        'important'
                    );
                }
            );


        document
            .querySelectorAll(
                '#header-toolbar li.search'
            )
            .forEach(
                function (element) {

                    element.style.setProperty(
                        'display',
                        'none',
                        'important'
                    );
                }
            );


        document
            .querySelectorAll(
                '#header-toolbar a[aria-label="Search"]'
            )
            .forEach(
                function (element) {

                    element.style.setProperty(
                        'display',
                        'none',
                        'important'
                    );
                }
            );
    }


    /* =========================================
       HIDE HEADER NAVIGATION
       ========================================= */

    function hideHeaderNavigation() {

        const selectors = [
            'a[aria-label="HOME"]',
            'a[aria-label="Contact Us"]',
            'a[aria-label="Sacred Saving"]'
        ];


        selectors.forEach(
            function (selector) {

                document
                    .querySelectorAll(
                        '#header-toolbar ' +
                        selector
                    )
                    .forEach(
                        function (element) {

                            const parent =
                                element.closest('li');

                            if (parent) {

                                parent.style.setProperty(
                                    'display',
                                    'none',
                                    'important'
                                );

                            } else {

                                element.style.setProperty(
                                    'display',
                                    'none',
                                    'important'
                                );
                            }
                        }
                    );
            }
        );
    }


    /* =========================================
       INITIALIZE
       ========================================= */

    function initialize() {

        hideOriginalSearch();

        hideHeaderNavigation();

        createPoojaPaathSearch();
    }


    /* =========================================
       START
       ========================================= */

    if (
        document.readyState ===
        'loading'
    ) {

        document.addEventListener(
            'DOMContentLoaded',
            initialize
        );

    } else {

        initialize();
    }


})();